"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluxErrorCodes = void 0;
exports.isFluxErrorCodeName = isFluxErrorCodeName;
exports.isFluxErrorCode = isFluxErrorCode;
exports.getFluxErrorCodeName = getFluxErrorCodeName;
const tslib_1 = require("tslib");
const invert_1 = tslib_1.__importDefault(require("lodash/invert"));
exports.FluxErrorCodes = {
    MissingActionDisplayStringError: 1003,
    UndefinedChangeHistoryEntryError: 1004,
    /**
     * @deprecated
     */
    GetSimInitDataError: 1006,
    GetUserByUidError: 1007,
    EmptyStringArgumentError: 1009,
    GetDocumentFromFirebaseError: 1010, // removed
    CaptureIntercomLeadError: 1011,
    KiCadPartImporterError: 1012,
    WriteActionRecordError: 1013,
    InvalidFirebaseEnvironmentError: 1014,
    CorruptedDocumentAssetsError: 1015,
    UserSignInError: 1017,
    UserSignUpError: 1018,
    CreateUserError: 1019,
    GenericError: 1020,
    DocumentReducerError: 1021,
    MissingArgumentReducerError: 1022,
    MissingFieldReducerError: 1023,
    S3GetError: 1024,
    InvalidActionRecordError: 1026,
    FetchActionRecordsError: 1028,
    PermissionDeniedError: 1031,
    GetPartError: 1035,
    InvalidRequestError: 1037,
    SvgMeshMergeError: 1040,
    SvgGroupCreateError: 1041,
    PerformanceBudgetViolationError: 1045,
    PerformanceMeasurementError: 1046,
    PcbLayoutNodeDataIntegrityError: 1047,
    GerberExporterError: 1048,
    PublishNewPartError: 1049,
    PublishNewPartVersionError: 1050,
    ApplyLatestDraftError: 1051,
    StartReceivingDraftsError: 1052,
    StopReceivingDraftsError: 1053,
    ApplyPartVersionError: 1054,
    ThreeDModelConversionError: 1055,
    FeatureFlagNotConfiguredError: 1057,
    FeatureFlagNotRetrievedError: 1058,
    FeatureFlagClientNotInitializedError: 1059,
    DeleteProjectError: 1060,
    MissingPartVersionDataError: 1061,
    AdminFirebaseConnectorError: 1064,
    DocumentExceededMaximumFirestoreDepthError: 1065,
    AnonymousSignInError: 1066,
    WriteDocumentConfigError: 1067,
    InvalidLayoutShapeDxfError: 1068,
    InvalidLayoutShapeSvgError: 1069,
    StorageError: 1070,
    NodeMissingElementError: 1071,
    MutateStorePartitionError: 1072,
    ImplictReparentingDeprecatedError: 1073,
    MissingChildUidError: 1074,
    ExportError: 1075,
    MissingElementDataError: 1076,
    WebGLError: 1077,
};
const inverted = (0, invert_1.default)(exports.FluxErrorCodes);
function isFluxErrorCodeName(name) {
    return name in exports.FluxErrorCodes;
}
function isFluxErrorCode(code) {
    return code in inverted;
}
function getFluxErrorCodeName(code) {
    return inverted[code];
}
//# sourceMappingURL=errorCodes.js.map